import { Card, Flex, Typography } from "antd";
import React from "react";

import tick from "../../../../assets/icons/tick-circle-white.svg";
import receipt from "../../../../assets/icons/receipt-text.svg";
import health from "../../../../assets/icons/health.svg";

export default function TreatmentsStatistics({ totalPatientResponsibility, activeTreatmentsCount }) {
  const testQuantities = [
    { title: "Total Revenue", value: 7500, icon: health, iconAlt: "health" },
    { title: "Ptient Responsibility By Active", value: `$${totalPatientResponsibility || "50,500"}`, icon: receipt, iconAlt: "receipt" },
    { title: "Active Treatments", value: `${activeTreatmentsCount || "6.7"}%`, icon: tick, iconAlt: "calendare-tick" },
  ];

  return (
    <div className="treatment-statistics-first-row">
      <Flex vertical gap={10} style={{ width: "100%" }}>
        {testQuantities.map((item, index) => (
          <Card key={index} size="small" style={{ padding: 5 }}>
            <Flex align="center" justify="space-between">
              <Flex vertical gap={5}>
                <Typography.Title level={4} style={{ marginBottom: 0 }} ellipsis>
                  {item.title}
                </Typography.Title>
                <Typography.Title level={4} style={{ marginTop: 0, color: "#6b43b5" }}>
                  {item.value}
                </Typography.Title>
              </Flex>

              <Flex align="center" justify="center" style={{ width: 73, height: 73, borderRadius: 100, backgroundColor: "#7F59CE" }}>
                <img src={item.icon} alt={item.iconAlt} />
              </Flex>
            </Flex>
          </Card>
        ))}
      </Flex>
    </div>
  );
}
